define('TescoMobile_Checkout/js/model/step-navigator-mixin',['mage/utils/wrapper', 'jquery', 'Magento_Checkout/js/model/quote', '../action/credit-check', '../model/payment-information', 'uiRegistry', 'Magento_Checkout/js/model/full-screen-loader', '../model/cancelled-order-processor', '../model/create-callback-url', 'TescoMobile_Iovation/js/model/device-fingerprint-config', '../checkout-fingerprint'], function (wrapper, $, quote, checkOrderAction, paymentInformation, registry, fullScreenLoader, cancelledOrderProcessor, createCallbackUrl, fingerprintConfig) {
  'use strict';

  let isLoading = false;
  function creditCheck(stepNavigator) {
    isLoading = true;
    const messageContainer = registry.get('checkout.errors').messageContainer;
    checkOrderAction(messageContainer).done(function (response) {
      isLoading = false;
      if (response.response_code === 'CO_280') {
        stepNavigator.setHash('t-and-c-step');
      } else if (response.response_code === 'CO_281') {
        paymentInformation.ccaIframeUrl(createCallbackUrl.cca(response.payment_iframe_url));
        stepNavigator.setHash('cca-step');
      } else if (response.response_code === 'CO_350') {
        paymentInformation.paymentIframeUrl(createCallbackUrl.payment(response.payment_iframe_url));
        stepNavigator.setHash('payment');
      } else if (['CO_185', 'CO_285'].includes(response.response_code)) {
        paymentInformation.response(response);
        paymentInformation.lockedSteps.push('monthly-payment');
        stepNavigator.setHash('monthly-payment');
      } else if (['CO_141', 'CO_145'].includes(response.response_code)) {
        cancelledOrderProcessor.setMessage(response);
      } else if (response.response_code === 'CO_140') {
        paymentInformation.response(response);
        let storeCode = quote.getStoreCode();
        let isDeliveryFromWarehouse = quote.getItems().filter(item => {
          var _item$tm_options;
          return (item === null || item === void 0 || (_item$tm_options = item.tm_options) === null || _item$tm_options === void 0 || (_item$tm_options = _item$tm_options.contract_type) === null || _item$tm_options === void 0 ? void 0 : _item$tm_options.toUpperCase()) !== 'SIMO';
        }).map(item => parseInt(item === null || item === void 0 ? void 0 : item.tm_use_store_stock)).includes(0);
        if (storeCode === 'instore' && !isDeliveryFromWarehouse) {
          stepNavigator.setHash('t-n-c-step');
        } else {
          stepNavigator.setHash('payment');
        }
      }
    }).always(function () {
      isLoading = false;
    });
  }
  return function (stepNavigator) {
    const hasQuoteLock = () => {
      var _quote$getData, _quote$getData2;
      return ((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_order_id) || ((_quote$getData2 = quote.getData('extension_attributes')) === null || _quote$getData2 === void 0 ? void 0 : _quote$getData2.tm_simo_locked);
    };
    const isStepLocked = code => hasQuoteLock() && stepNavigator.isProcessed(code);
    stepNavigator.handleHash = wrapper.wrapSuper(stepNavigator.handleHash, function () {
      const hashString = window.location.hash.replace('#', ''),
        hash = window.location.hash,
        id = $(hash);
      if (isLoading) {
        return false;
      }
      if (isStepLocked(hashString)) {
        stepNavigator.setHash(hashString);
        return false;
      }
      if (hasQuoteLock() && !paymentInformation.lockedSteps().includes(hashString)) {
        var _quote$getData3;
        if ((_quote$getData3 = quote.getData('extension_attributes')) !== null && _quote$getData3 !== void 0 && _quote$getData3.tm_simo_locked && stepNavigator.validCodes.includes('imei') && quote.getItems().map(item => item === null || item === void 0 ? void 0 : item.tm_mpn).filter(x => x).length === 0) {
          paymentInformation.lockedSteps.push('imei');
          stepNavigator.setHash('imei');
          this._super();
        } else {
          if (fingerprintConfig.isRetryVersionEnabled) {
            creditCheck(stepNavigator);
          } else {
            if (!fingerprintConfig.isFingerprintSaved) {
              fullScreenLoader.startLoader();
              setTimeout(function () {
                fullScreenLoader.stopLoader();
                stepNavigator.handleHash();
              }, 50);
            } else {
              creditCheck(stepNavigator);
              this._super();
            }
          }
        }
      } else {
        this._super();
        if (id.length > 0 && hashString === 'about') {
          $('html, body').animate({
            scrollTop: id.offset().top - 62
          }, 100);
        }
      }
    });
    stepNavigator.navigateTo = wrapper.wrapSuper(stepNavigator.navigateTo, function (code, scrollToElementId) {
      if (isStepLocked(code)) {
        return;
      }
      this._super(code, scrollToElementId);
    });
    stepNavigator.setHash = wrapper.wrapSuper(stepNavigator.setHash, function (hash) {
      if (isStepLocked(hash)) {
        return;
      }
      this._super(hash);
    });
    stepNavigator.isStepLocked = function (code) {
      return isStepLocked(code) || paymentInformation.lockedSteps().includes(window.location.hash.replace('#', ''));
    };
    stepNavigator.previousStep = function () {
      var activeIndex = 0,
        code;
      this.steps().sort(this.sortItems).forEach(function (element, index) {
        if (element.isVisible()) {
          element.isVisible(false);
          activeIndex = index;
        }
      });
      if (activeIndex > 0 && this.steps().length > activeIndex - 1) {
        code = this.steps()[activeIndex - 1].code;
        this.steps()[activeIndex - 1].isVisible(true);
        this.setHash(code);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    };
    return stepNavigator;
  };
});

